import * as React from "react";
import { useMemo } from "react";
import { createGRN } from "logic/permissions/GRN";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import { Link } from "components/common";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import useEntityCollectionStatus from "../hooks/useEntityCollectionStatus";
import CollectionsRoutes from "../Routes";
const EntityCollectionList = ({ collections }) => {
  const collectionList = useMemo(
    () => collections.map((collection) => /* @__PURE__ */ React.createElement(ListGroupItem, { key: collection.id }, /* @__PURE__ */ React.createElement(Link, { to: CollectionsRoutes.show(collection.id) }, collection.title))),
    [collections]
  );
  return /* @__PURE__ */ React.createElement(ListGroup, { componentClass: "ul" }, collectionList);
};
const EntityCollectionExpandedSection = ({ entity, entityType }) => {
  const { t } = useTranslation("enterprise_collections");
  const entityGRN = createGRN(entityType, entity.id);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entity.id);
  if (isFetching || isError) {
    return /* @__PURE__ */ React.createElement("p", null, t("entity_collection_expanded.loading"));
  }
  if (!(data == null ? void 0 : data.length)) {
    return /* @__PURE__ */ React.createElement("p", null, "The ", entityType, " ", entity.title, " is not part of any collection.");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("entity_collection_expanded.description", { entityType, title: entity.title })), /* @__PURE__ */ React.createElement(EntityCollectionList, { collections: data || [] }));
};
const getRenderExpandCollections = (entityType) => (entity) => /* @__PURE__ */ React.createElement(EntityCollectionExpandedSection, { entity, entityType });
export const expandedCollectionSections = (entiyType) => ({
  collections: {
    title: i18n.t("shared.collections", { ns: "enterprise_collections" }),
    content: getRenderExpandCollections(entiyType)
  }
});
export default EntityCollectionExpandedSection;
